import React from "react";
import "./index.css";
import { motion } from "framer-motion";
import { iconos } from "../../../assets";

const Modalidades = ({ variants }) => {
    const modalidades = [
        {
            title: "Staffing",
            description: "Developers for specific timeframes.",
            details: "Onboard experts to your team temporarily.",
            icon: iconos.staffing
        },
        {
            title: "Dedicated Teams",
            description: "A full team of AI specialists for the client.",
            details: "Comprehensive management and exclusive expertise.",
            icon: iconos.equipos
        },
        {
            title: "Turnkey Solutions",
            description: "Full technology project management from start to finish.",
            details: "From ideation to final implementation.",
            icon: iconos.llave
        }
    ];

    return (
        <div className="modalidades section relative">
            <div className="container-lg flex flexCol alignCenter">
                <motion.h2
                    variants={variants}
                    initial="initial"
                    whileInView="ani"
                    viewport={{ once: true }}
                    className="modalidadesTitle"
                >
                    Engagement Models
                </motion.h2>
                <div className="modalidadesGrid">
                    {modalidades.map((mod, index) => (
                        <motion.div
                            key={index}
                            className="modCard"
                            variants={variants}
                            initial="initial"
                            whileInView="ani"
                            viewport={{ once: true }}
                            custom={index * 0.2}
                        >
                            <div className="modIcon">
                                <img src={mod.icon.src} alt={mod.title} />
                            </div>
                            <div className="modContent">
                                <h3>{mod.title}</h3>
                                <p className="modDesc">{mod.description}</p>
                                <p className="modDetails">{mod.details}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Modalidades;
